import {User} from '../models/user';

export class UsersRepository {
    private map = new Map<number, User>();

    constructor(seed: User[]) {
        seed.forEach((user) => this.map.set(user.id, user));
    }

    public findById(id: number) {
        return this.map.get(id);
    }
}
